export function resolveShopManagementNavItems(pageProps = {}) {
  const navItems = pageProps.shopManagementNavigation;

  return Array.isArray(navItems) ? navItems : [];
}
